import { render, staticRenderFns } from "./InspectionPointAdd.vue?vue&type=template&id=77b0b6d1&scoped=true"
import script from "./InspectionPointAdd.vue?vue&type=script&lang=js"
export * from "./InspectionPointAdd.vue?vue&type=script&lang=js"
import style0 from "./InspectionPointAdd.vue?vue&type=style&index=0&id=77b0b6d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b0b6d1",
  null
  
)

export default component.exports